import { render } from "./B2bPageFacturasRecibidas.vue?vue&type=template&id=f7ea6362&scoped=true&lang=pug"
import script from "./B2bPageFacturasRecibidas.vue?vue&type=script&lang=js"
export * from "./B2bPageFacturasRecibidas.vue?vue&type=script&lang=js"

import "./B2bPageFacturasRecibidas.vue?vue&type=style&index=0&id=f7ea6362&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7ea6362"]])

export default __exports__